import { Skeleton } from '@/components/ui/skeleton';
import { PageHeaderSkeleton } from './PageHeaderSkeleton';
import { CardGridSkeleton } from './CardGridSkeleton';
import { PageWrapper } from '@/components/layout';

/**
 * Skeleton for the Legislators page.
 * Reserves ~640px total height to prevent CLS.
 *
 * Layout breakdown:
 * - PageHeader with gradient: ~130px
 * - Year selector card: ~70px
 * - Filters section: ~100px
 * - Results summary: ~20px
 * - Card grid (6 cards): ~320px
 */
export function LegislatorsPageSkeleton() {
  return (
    <PageWrapper
      header={<PageHeaderSkeleton variant="gradient" showDescription={true} childrenHeight={40} />}
    >
      <div className="space-y-6 mb-12">
        {/* Year Selector Card */}
        <div className="bg-card border border-border rounded-lg shadow-sm p-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <Skeleton className="h-5 w-5 rounded" />
              <Skeleton className="h-5 w-32" />
            </div>
            <Skeleton className="h-9 w-[180px]" />
          </div>
        </div>

        {/* Filters Section */}
        <div className="bg-card border border-border rounded-lg shadow-sm p-4 space-y-4">
          {/* Search Row */}
          <Skeleton className="h-10 w-full sm:w-80" />

          {/* Filter Dropdowns Row */}
          <div className="flex flex-wrap gap-2">
            <Skeleton className="h-10 w-28" />
            <Skeleton className="h-10 w-28" />
            <Skeleton className="h-10 w-28" />
            <Skeleton className="h-10 w-28" />
            <Skeleton className="h-10 w-24" />
          </div>
        </div>

        {/* Results */}
        <div className="space-y-4">
          {/* Results Summary */}
          <div className="flex items-center justify-between text-sm">
            <Skeleton className="h-4 w-36" />
          </div>

          {/* Legislators Grid */}
          <CardGridSkeleton count={6} />
        </div>
      </div>
    </PageWrapper>
  );
}
